module.exports = __webpack_public_path__ + "static/img/logo11.b78efd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo11.jpg
// module id = cOLt
// module chunks = 1